import { DropDownList } from "@repo/ui";

import type { LayerFilterProps } from "../hooks/useUpdateLayerFilter";

import { ClientSideLabel } from "./clientSideLabel";

const ACTIVE_STATUS_OPTIONS = [
	{ id: 0, value: "All" },
	{ id: 1, value: "Active" },
	{ id: 2, value: "Inactive" },
];

export function ActiveStatusDropdown({ layer, updateFilter, label }: LayerFilterProps & { label: string }) {
	return (
		<DropDownList
			label={<ClientSideLabel label={label} />}
			placeholder="All Statuses"
			value={layer.statusId}
			changeHandler={(value) => updateFilter(value, "statusId")}
			values={ACTIVE_STATUS_OPTIONS}
			valueProp="id"
			textProp="value"
			fullLength
			clearable
		/>
	);
}
